import axios from "axios";

import { toast } from "react-toastify";
import { isToastUnavailableRoute } from "../../shared/helpers/is-toast-unavailble-route";
import { signoutRequest } from "../openid/openid-manager";
import { isLoaderUnavailableRoute } from "../../shared/helpers/is-loader-unavailable-route";

let numberOfAjaxCAllPending = 0;

const axiosInstanceAssetRevamp = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_SLP_SAVEASSETREVAMP,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstanceAssetRevamp.interceptors.request.use(
  function (config) {
    numberOfAjaxCAllPending++;

    const isLoaderUnavailable = isLoaderUnavailableRoute(
      config.url,
      config?.method,
    );

    if (
      isLoaderUnavailable ||
      (config?.method == "get" &&
        !config.url?.includes("slpapp/aams/getpermission"))
    ) {
      // Do not show loader
    } else {
      document.body.classList.add("loading-indicator");
    }

    return config;
  },

  function (error) {
    numberOfAjaxCAllPending--;

    if (numberOfAjaxCAllPending <= 0) {
      numberOfAjaxCAllPending = 0;
      document.body.classList.remove("loading-indicator");
    }

    throw error;
  },
);

axiosInstanceAssetRevamp.interceptors.response.use(
  function (response) {
    numberOfAjaxCAllPending--;

    if (numberOfAjaxCAllPending == 0) {
      document.body.classList.remove("loading-indicator");
    }

    const { method } = response.config;

    const responseURL = response.request.responseURL;

    const isAvailable = isToastUnavailableRoute(responseURL);

    if (
      (method === "put" ||
        method === "post" ||
        method === "delete" ||
        method === "DELETE") &&
      !isAvailable
    ) {
      if (response?.data?.message || response?.data?.error) {
        if ([200, 201].includes(response?.data?.status)) {
          toast.success(response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          });
        } else if ([204, 400, 401, 403, 404].includes(response?.data?.status)) {
          toast.warning(response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          });
        } else {
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : response?.data?.error,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              draggable: true,
              pauseOnHover: true,
            },
          );
        }
      }
    }

    return response;
  },
  async function (error) {
    numberOfAjaxCAllPending--;

    if (numberOfAjaxCAllPending <= 0) {
      numberOfAjaxCAllPending = 0;
      document.body.classList.remove("loading-indicator");
    }

    if (error?.response?.status === 401) {
      await signoutRequest(false);
      if (error?.request?.responseURL.includes("/api/slpapp/Mfa")) return;
      window.location.reload();
    }

    const { method } = error.config;
    const responseURL = error.request.responseURL;

    const isAvailable = isToastUnavailableRoute(responseURL);

    if (
      (method === "put" ||
        method === "post" ||
        method === "delete" ||
        method === "DELETE") &&
      !isAvailable
    ) {
      toast.error("An error occurred", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      });
    }

    throw error;
  },
);

export default axiosInstanceAssetRevamp;
